<nb-card>
  <nb-card-header>Change event details</nb-card-header>
  <nb-card-body>
    <form [formGroup]="eventDetailForm" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="form-group" *ngIf="imgFile">
        <img [src]="imgFile" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group" *ngIf="!imgFile">
        <img id="logo" [src]="logoURL" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group">
        <label class="upload" for="file" type="button">UPLOAD NEW LOGO</label>
        <input type="file" nbInput class="form-control" id="file" formControlName="file"
          (change)="onImageChange($event)">
      </div>
      <div class="form-group" *ngIf="imgCouponFile">
        <img [src]="imgCouponFile" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group" *ngIf="!imgCouponFile">
        <img id="couponLogo" [src]="couponURL" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group">
        <label class="upload" for="couponFile" type="button">UPLOAD NEW COUPON</label>
        <input type="file" nbInput class="form-control" id="couponFile" formControlName="couponFile"
          (change)="onCouponChange($event)">
      </div>
      <div class="form-group" *ngIf="imgBannerFile">
        <img [src]="imgBannerFile" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group" *ngIf="!imgBannerFile">
        <img id="bannerLogo" [src]="bannerURL" style="width:400px; height:400px" alt="No image found">
      </div>
      <div class="form-group">
        <label class="upload" for="bannerFile" type="button">UPLOAD NEW BANNER</label>
        <input type="file" nbInput class="form-control" id="bannerFile" formControlName="bannerFile"
          (change)="onBannerChange($event)">
      </div>
      <div class="form-group">
        <label for="name" class="label">Name</label>
        <input type="text" nbInput fullWidth id="name" placeholder="Name" formControlName="name"
          [status]="e.name.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="description" class="label">Description</label>
        <textarea type="text" nbInput fullWidth id="description" placeholder="Description" formControlName="description"
          [status]="e.description.errors ? 'danger' : ''"></textarea>
      </div>
      <!--Host details-->
      <div class="form-group">
        <label for="showEventHostDetails" class="label">Show host details in app</label><br />
        <nb-checkbox id="showEventHostDetails" formControlName="showEventHostDetails"></nb-checkbox>
      </div>
      <div class="form-group">
        <label for="hostCompany" class="label">Host company</label>
        <input type="text" nbInput fullWidth id="hostCompany" placeholder="Host company" formControlName="hostCompany"
          [status]="e.hostCompany.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="hostName" class="label">Host name</label>
        <input type="text" nbInput fullWidth id="hostName" placeholder="Host name" formControlName="hostName"
          [status]="e.hostName.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="hostAddress" class="label">Host address</label>
        <input type="text" nbInput fullWidth id="hostAddress" placeholder="Host address" formControlName="hostAddress"
          [status]="e.hostAddress.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="hostPhone" class="label">Host phone</label>
        <input type="text" nbInput fullWidth id="hostPhone" placeholder="Host phone" formControlName="hostPhone"
          [status]="e.hostPhone.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="hostEmail" class="label">Host e-mail</label>
        <input type="text" nbInput fullWidth id="hostEmail" placeholder="Host e-mail" formControlName="hostEmail"
          [status]="e.hostEmail.errors ? 'danger' : ''">
      </div>
      <!--Pricing details-->
      <div class="form-group">
        <label for="couponPrice" class="label">Coupon price</label>
        <input type="number" nbInput fullWidth id="couponPrice" placeholder="0" formControlName="couponPrice"
          [status]="e.couponPrice.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="minimumAmountOfCoupons" class="label">Minimum # coupons</label>
        <input type="number" nbInput fullWidth id="minimumAmountOfCoupons" placeholder="0"
          formControlName="minimumAmountOfCoupons" [status]="e.minimumAmountOfCoupons.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="minimumAmountForFreeTransaction" class="label">Minimum amount for free transaction</label>
        <input type="number" nbInput fullWidth id="minimumAmountForFreeTransaction" placeholder="0"
          formControlName="minimumAmountForFreeTransaction"
          [status]="e.minimumAmountForFreeTransaction.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="transactionFee" class="label">Transaction fee</label>
        <input type="number" nbInput fullWidth id="transactionFee" placeholder="0" formControlName="transactionFee"
          [status]="e.transactionFee.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="allowRefund" class="label">Allow refunds</label><br />
        <nb-checkbox id="allowRefund" formControlName="allowRefund"></nb-checkbox>
      </div>
      <div class="form-group">
        <label for="allowRefundToCharity" class="label">Allow refund to charity</label><br />
        <nb-checkbox id="allowRefundToCharity" formControlName="allowRefundToCharity"></nb-checkbox>
      </div>
      <div class="form-group">
        <label for="allowRefundToMyAccount" class="label">Allow refund to bank account</label><br />
        <nb-checkbox id="allowRefundToMyAccount" formControlName="allowRefundToMyAccount"></nb-checkbox>
      </div>
      <!--Location details-->
      <div class="form-group">
        <label for="addressSearch" class="label">Enter address</label>
        <input type="text" nbInput fullWidth id="addressSearch" class="form-control"
          (keydown.enter)="$event.preventDefault()" placeholder="Search Nearest Location"
          autocomplete="new-address-field" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
      </div>
      <!--
      <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
        <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
          (dragEnd)="markerDragEnd($event)"></agm-marker>
      </agm-map>
      -->
      <div class="form-group">
        <label for="lat" class="label">Latitude</label>
        <input type="text" nbInput fullWidth id="lat" placeholder="Latitude" formControlName="lat"
          [status]="e.lat.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="lng" class="label">Longitude</label>
        <input type="text" nbInput fullWidth id="lng" placeholder="Longitude" formControlName="lng"
          [status]="e.lng.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="payNLAPIToken" class="label">payNL API Token</label>
        <input type="text" nbInput fullWidth id="payNLAPIToken" placeholder="93a0b63ef6bd3c38780285cb9b8579f17d1d01e3"
          formControlName="payNLAPIToken" [status]="e.lat.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="payNLServiceId" class="label">payNL Service Id</label>
        <input type="text" nbInput fullWidth id="payNLServiceId" placeholder="SL-3699-4491"
          formControlName="payNLServiceId" [status]="e.lng.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="payconiqAPIKey" class="label">Payconiq API Key</label>
        <input type="text" nbInput fullWidth id="payconiqAPIKey" placeholder="552d9bcc-dde1-4bfa-87df-5d08679baddc"
          formControlName="payconiqAPIKey" [status]="e.lat.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="payconiqMerchantId" class="label">Payconiq Merchant Id</label>
        <input type="text" nbInput fullWidth id="payconiqMerchantId" placeholder="5ee37a28a562e900063ce332"
          formControlName="payconiqMerchantId" [status]="e.lng.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="payconiqMerchantURL" class="label">Payconiq Merchant URL</label>
        <input type="text" nbInput fullWidth id="payconiqMerchantURL" placeholder="https://api.payconiq.com/v3/payments"
          formControlName="payconiqMerchantURL" [status]="e.lat.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="payconiqProfileId" class="label">Payconiq Profile Id</label>
        <input type="text" nbInput fullWidth id="payconiqProfileId" placeholder="5ee37a28a562e900063ce332"
          formControlName="payconiqProfileId" [status]="e.lat.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="startDate" class="label">Start date</label>
        <input nbInput fullWidth placeholder="Start date" [nbDatepicker]="startDatePicker" id="startDate"
          formControlName="startDate" [status]="e.startDate.errors ? 'danger' : ''">
        <nb-date-timepicker #startDatePicker></nb-date-timepicker>
      </div>
      <div class="form-group">
        <label for="endDate" class="label">End date</label>
        <input nbInput fullWidth placeholder="End date" [nbDatepicker]="endDatePicker" id="endDate"
          formControlName="endDate" [status]="e.endDate.errors ? 'danger' : ''">
        <nb-date-timepicker #endDatePicker></nb-date-timepicker>
      </div>
      <button type="submit" nbButton status="success">Save</button>
    </form>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="!showEventStand">
  <nb-card-header>Event stands</nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="settings" [source]="source" (delete)="onDelete($event)" (edit)="onEdit($event)"
      (create)="onCreate()">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="showEventStand">
  <nb-card-header>Event stands</nb-card-header>
  <nb-card-body>
    <form [formGroup]="eventStandForm" (ngSubmit)="onSubmitEventStand()">
      <div class="form-group">
        <label for="eventStandName" class="label">Name</label>
        <input type="text" nbInput fullWidth id="eventStandName" placeholder="Name" formControlName="eventStandName"
          [status]="s.eventStandName.errors ? 'danger' : ''">
      </div>
      <div class="form-group">
        <label for="category" class="label">Category</label><br />
        <nb-select multiple placeholder="Select categories" formControlName="categories" fullWidth>
          <nb-option *ngFor="let category of category_data" [value]="category.key">{{category.name}}</nb-option>
        </nb-select>
      </div>
      <ng-container *ngIf="showBusinessDetails">
        <div class="form-group">
          <label for="eventStandAddress" class="label">Address</label>
          <input type="text" nbInput fullWidth id="eventStandAddress" placeholder="Address"
            formControlName="eventStandAddress" [status]="s.eventStandAddress.errors ? 'danger' : ''">
        </div>
        <div class="form-group">
          <label for="eventStandEmail" class="label">E-mail</label>
          <input type="text" nbInput fullWidth id="eventStandEmail" placeholder="E-mail"
            formControlName="eventStandEmail" [status]="s.eventStandEmail.errors ? 'danger' : ''">
        </div>
        <div class="form-group">
          <label for="eventStandVatNr" class="label">VAT number</label>
          <input type="text" nbInput fullWidth id="eventStandVatNr" placeholder="VAT number"
            formControlName="eventStandVatNr" [status]="s.eventStandVatNr.errors ? 'danger' : ''">
        </div>
        <div class="form-group">
          <label for="eventStandBankAccount" class="label">Bank account</label>
          <input type="text" nbInput fullWidth id="eventStandBankAccount" placeholder="Bank account"
            formControlName="eventStandBankAccount" [status]="s.eventStandBankAccount.errors ? 'danger' : ''">
        </div>
        <div class="form-group">
          <label for="eventStandPhoneNr" class="label">Phone number</label>
          <input type="text" nbInput fullWidth id="eventStandPhoneNr" placeholder="Phone number"
            formControlName="eventStandPhoneNr" [status]="s.eventStandPhoneNr.errors ? 'danger' : ''">
        </div>
        <div class="form-group">
          <label for="eventStandClientId" class="label">Client id</label>
          <input type="text" nbInput fullWidth id="eventStandClientId" placeholder="Client id"
            formControlName="eventStandClientId" [status]="s.eventStandClientId.errors ? 'danger' : ''">
        </div>
      </ng-container>
      <div class="form-group">
        <button class="margin-right" type="submit" nbButton status="success">Save</button>
        <button class="margin-right" type="reset" (click)="onCancel()" nbButton status="danger">Cancel</button>
      </div>
    </form>
  </nb-card-body>
</nb-card>

<nb-card>
  <nb-card-header>SEPA files</nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <label for="sendMails" class="label">Send mails to merchants</label><br />
      <nb-checkbox id="sendMails" formControlName="showEventHostDetails" [(checked)]="sendMails"></nb-checkbox>
    </div>
    <div class="form-group">
      <button nbButton (click)="generateSepa()" status="danger">Generate a new SEPA file</button>
    </div>
    <angular2-smart-table [settings]="sepaSettings" [source]="sepaSource"  (delete)="onDeleteSepa($event)">
    </angular2-smart-table>  </nb-card-body>
</nb-card>

<nb-card>
  <nb-card-header>Danger zone</nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <button nbButton (click)="deactivateUsers()" status="danger">Deactivate all users for this event</button>
    </div>
  </nb-card-body>
</nb-card>